import { DiagramEventEmitter } from "../../../../diagram/modules/DiagramEventEmitter";
import { DIAGRAM_EMIT_EVENTS } from "../../../../diagram/modules/DiagramEvents";
import { GridSizedViewUtils } from "../../utils/GridSizeViewUtils";
import { CellRetrievalUtils } from "../../utils/CellRetrievalUtils";

export const CellSelection = (function () {
    const instance = {};
    class CellSelection {
        lastSelectedCell = null;

        instanceUuid;

        eventEmitter;

        grid;

        lastEmittedValue;

        cellRetrieval = new CellRetrievalUtils();

        constructor(diagramInstanceUuid) {
            if (!instance[diagramInstanceUuid]) {
                // setting the singleton instance
                instance[diagramInstanceUuid] = this;
                this.instanceUuid = diagramInstanceUuid;
                this.eventEmitter = new DiagramEventEmitter(this.instanceUuid);
            }
            return instance[diagramInstanceUuid];
        }

        /**
         * @description updates the previously selected cell
         * @param {*} grid
         */
        updatePreviouslySelectedCell(grid) {
            this.grid = grid;
            let cellRef;
            if (this.lastSelectedCell) {
                cellRef = this.cellRetrieval.getCell(this.lastSelectedCell, grid);
                cellRef.update({}, { selected: false });
                cellRef.draw();
            }
            return cellRef;
        }

        /**
         * @description
         * @param {*} instanceUuid
         */
        destroy(instanceUuid) {
            this.lastEmittedValue = null;
            this.lastSelectedCell = null;
            instance[instanceUuid] = null;
            delete instance[instanceUuid];
        }

        /**
         * @description Handles the click selection
         * @param {*} payload - mouse position {x,y}
         * @param {*} grid - generated grid matrix
         */
        handleClickSelection(payload, grid) {
            this.grid = grid;
            const gridSizeUtils = new GridSizedViewUtils();
            const newCell = gridSizeUtils.getPermanentGridCellPos(payload, grid);
            let diffCells = false;

            if (this.lastSelectedCell && newCell) {
                diffCells = gridSizeUtils.differentCell(this.lastSelectedCell, newCell);
            }
            if ((this.lastSelectedCell && diffCells) || (this.lastSelectedCell && !newCell)) {
                const oldCell = this.cellRetrieval.getCell(this.lastSelectedCell, grid);
                oldCell.update({}, { selected: false });
                oldCell.draw();
            }
            if (!newCell) {
                this.setSelectedCell(null);
            }
            if (newCell) {
                this.setSelectedCell(newCell);
                const currentCell = this.cellRetrieval.getCell(newCell, grid);
                if (currentCell && currentCell.hasContent()) {
                    currentCell.update({}, { selected: !(currentCell.state && currentCell.state.disabled) });
                    currentCell.draw();
                } else {
                    this.setSelectedCell(null);
                }
            }
            return this.lastSelectedCell;
        }

        /**
         * @description Handles the double click selection
         * @param {*} payload - mouse position {x,y}
         * @param {*} grid - generated grid matrix
         */
        handleDoubleClickSelection(payload, grid) {
            const gridSizeUtils = new GridSizedViewUtils();
            const newCell = gridSizeUtils.getPermanentGridCellPos(payload, grid);
            if (newCell) {
                const cellRef = this.cellRetrieval.getCell(newCell, this.grid);
                const content = cellRef.getContentInstance();
                if (content) {
                    this.eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.PLUGIN_DBLCLICK_SELECTED, { PLUGIN_ID: content.data.id, PLUGIN_UUID: content.uuid, doubleClickEvent: true });
                }
            }
        }

        /**
         * @deescription Sets the cell as selected
         * @param {GridCell} cell - cell in question
         * @param {Boolean} noEventEmission - indicates if events should be emitted
         * @param {Object[]} grid -  generated grid matrix
         */
        setSelectedCell(cell, noEventEmission, grid) {
            if (grid) this.grid = grid;
            if (this.lastSelectedCell && this.lastSelectedCell !== cell && this.grid) {
                const cellRef = this.cellRetrieval.getCell(this.lastSelectedCell, this.grid);
                cellRef.update({}, { selected: false });
                cellRef.draw();
            }
            this.lastSelectedCell = cell;
            if (grid) this.grid = grid;
            const cellRef = this.cellRetrieval.getCell(this.lastSelectedCell, this.grid);
            if (this.lastSelectedCell && cellRef.getContentInstance()) {
                const content = cellRef.getContentInstance();
                const pluginId = content.data.id;
                const pluginUuid = content.uuid;
                if (noEventEmission) {
                    const oldCell = this.cellRetrieval.getCell(this.lastSelectedCell, this.grid);
                    oldCell.update({}, { selected: true });
                    oldCell.draw();
                    return;
                }
                const toEmitValue = { PLUGIN_ID: pluginId, PLUGIN_UUID: pluginUuid };
                // if (this.lastEmittedValue && this.lastEmittedValue.triggeredFirstTime) { delete this.lastEmittedValue.triggeredFirstTime }
                if (this.shouldNotEmitAgain(toEmitValue)) return;
                this.lastEmittedValue = toEmitValue;
                this.eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.PLUGIN_SELECTED, toEmitValue);
            } else {
                if (noEventEmission) return;
                const toEmitValue = { PLUGIN_UUID: null, PLUGIN_ID: null };
                if (this.shouldNotEmitAgain(toEmitValue)) return;
                this.lastEmittedValue = toEmitValue;
                // this.lastEmittedValue["triggeredFirstTime"] = true;
                this.eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.PLUGIN_SELECTED, { PLUGIN_UUID: null, PLUGIN_ID: null });
            }
        }

        /**
         * @description schecks if the event should be emitted again
         * @param {*} toEmitValue
         */
        shouldNotEmitAgain(toEmitValue) {
            if (!this.lastEmittedValue) return false;
            // if (this.lastEmittedValue.triggeredFirstTime) { return true };
            if (toEmitValue.PLUGIN_ID && toEmitValue.PLUGIN_UUID && this.lastEmittedValue.PLUGIN_ID === toEmitValue.PLUGIN_ID && this.lastEmittedValue.PLUGIN_UUID === toEmitValue.PLUGIN_UUID) return true;
        }

        /**
         * @description returns the selected cell
         */
        getSelected() {
            return this.lastSelectedCell;
        }

        /**
               * @description returns the selected cell content
               */
        getSelectedCellContent(newGrid) {
            return this.cellRetrieval.getCell(this.lastSelectedCell, newGrid);
        }
    }
    return CellSelection;
}());
